import React from 'react';
import { TextField, TextFieldProps, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const S10Blueblue300 = "#63AFC8";
const S10Blueblue700 = "#10617B";
const S10Greygrey100 = "#B8B8B8";
const S10Greygrey700 = "#131313";
const S10Redred500 = "#B50808";

const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    margin: 0,
    padding: 0,
  },
  label: {
    color: S10Greygrey700,
    fontSize: '16px',
    // fontWeight: "300 !important",
    lineHeight: 1.25,
    marginBottom: '0.25rem',
  },
  inputRoot: {
    // width: '20rem !important',
    // height: '2.5rem !important',
    backgroundColor: 'white',
    borderRadius: '0.25rem',
    border: `1px solid ${S10Greygrey100}`,
    transition: 'border 0.2s',
    '&:hover': {
      border: `1px solid ${S10Blueblue700} !important`,
    },
    '&.Mui-focused': {
      border: `1px solid ${S10Blueblue700} !important`,
    },
  },
  inputError: {
    border: `1px solid ${S10Redred500} !important`,
  },
  inputValueNonError: {
    border: `1px solid ${S10Blueblue300} !important`,
  },
  textField: {
    '& .MuiOutlinedInput-root': {
      fieldset: {
        border: 'none',
      },
    },
    '& .MuiInputBase-input': {
      padding: '0.5rem 0.75rem',
      fontSize: '1rem',
      boxSizing: 'border-box',
    },
    '& .MuiFormControl-root': {
      margin: 0,
    },
  },
}));

interface MyTextFieldProps extends Omit<TextFieldProps, 'variant'> {
  label?: string;
}

const MyTextField: React.FC<MyTextFieldProps> = ({ label, error, value, ...props }) => {
  const classes = useStyles();

  let borderClass = '';
  if (error) {
    borderClass = classes.inputError;
  } else if (value && !error) {
    borderClass = classes.inputValueNonError;
  }

  return (
    <div className={classes.container}>
      {label && (
        <Typography className={classes.label} component="label" style={{fontWeight: 400}}>
          {label}
        </Typography>
      )}
      <TextField
        {...props}
        value={value}
        error={error}
        variant="outlined"
        margin="none"
        className={classes.textField}
        InputProps={{
          ...props.InputProps,
          className: `${classes.inputRoot} ${borderClass}`,
        }}
        inputProps={{
          style: { height: '1.8rem', padding: '0.5rem 0.75rem' },
        }}
        FormHelperTextProps={{ style: { marginLeft: 0, fontSize: '0.75rem', marginTop: '4px' } }}
      />
    </div>
  );
};

export default MyTextField;